import { makeAutoObservable } from "mobx"

export default class Document {

  constructor(document={}) {
    this.id = document.id
    this.token = document.token
    this.documentable_id = document.documentable_id
    this.documentable_type = document.documentable_type
    this.file_name = document.file_name || ''

    makeAutoObservable(this)
  }
}
